var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18894 0.197889L5.84792 4.63061C5.90322 4.68338 5.94248 4.74055 5.96571 4.80211C5.98893 4.86368 6.00036 4.92964 5.99999 5C5.99999 5.07036 5.98856 5.13632 5.96571 5.19789C5.94285 5.25945 5.90359 5.31662 5.84792 5.36939L1.18894 9.8153C1.05991 9.93843 0.898615 10 0.705067 10C0.511519 10 0.345621 9.93404 0.207372 9.80211C0.0691233 9.67018 -9.11385e-07 9.51627 -8.96008e-07 9.34037C-8.8063e-07 9.16447 0.0691234 9.01055 0.207372 8.87863L4.27188 5L0.207372 1.12137C0.0783404 0.998241 0.0138243 0.846438 0.0138243 0.665963C0.0138243 0.485488 0.0829486 0.329463 0.221198 0.197889C0.359446 0.0659633 0.520736 4.74662e-07 0.705068 4.90777e-07C0.889399 5.06891e-07 1.05069 0.0659633 1.18894 0.197889Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.96a932d01eb76527edd3b3def01fd85d.svg";
export { ForwardRef as ReactComponent };